import React, { useEffect } from 'react';

const AuthComponent = (components) => {
  useEffect(() => {
    const auth = sessionStorage.getItem('authSignal');
    console.log(auth);
    if (auth === 'true') {
      return components;
    }
  }, []);
};

export default AuthComponent;
